<template>
  <mobile v-if="gl.isMobile" />
  <desktop v-else />
</template>

<script>
// store
import { useGl } from '@store/ts/gl';

// components
import Desktop from './desktop.vue';
import Mobile from './mobile.vue';

export default {
    name: 'bot-clone-more',
    components: {
        Mobile,
        Desktop,
    },
    setup() {
        // store
        const gl = useGl();
    
        return {
            gl,
        };
    },
};
</script>